import { useEffect, useState } from 'react';

/**
 * Hook to get the current `innerWidth` of the window.
 * @returns {windowSize} number - current window size
 */
export function useWindowSize(): number | undefined {
  const [windowSize, setWindowSize] = useState<number>();

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(window.innerWidth);
    };
    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return windowSize;
}
